import { ResidentShiftHandoverScreen } from "app/screens/residents/show/ResidentShiftHandoverScreen";

export default function ResidentShiftHandoverPage() {
  return <ResidentShiftHandoverScreen />;
}
